export enum TaxiCorporationPlanEntryBillingsDownloadRequestOrder {
  DISTANCE_ASC = "DISTANCE_ASC",
  DISTANCE_DESC = "DISTANCE_DESC",
  HIGHWAY_CHARGE_ASC = "HIGHWAY_CHARGE_ASC",
  HIGHWAY_CHARGE_DESC = "HIGHWAY_CHARGE_DESC",
  HUMAN_ID_ASC = "HUMAN_ID_ASC",
  HUMAN_ID_DESC = "HUMAN_ID_DESC",
  DRIVER_ASC = "DRIVER_ASC",
  DRIVER_DESC = "DRIVER_DESC",
  BILLING_MODEL_ASC = "BILLING_MODEL_ASC",
  BILLING_MODEL_DESC = "BILLING_MODEL_DESC",
  DISTANCE_RATE_ASC = "DISTANCE_RATE_ASC",
  DISTANCE_RATE_DESC = "DISTANCE_RATE_DESC",
  DISTANCE_AMOUNT_ASC = "DISTANCE_AMOUNT_ASC",
  DISTANCE_AMOUNT_DESC = "DISTANCE_AMOUNT_DESC",
  TOTAL_AMOUNT_ASC = "TOTAL_AMOUNT_ASC",
  TOTAL_AMOUNT_DESC = "TOTAL_AMOUNT_DESC",
}

export enum TaxiCorporationPlanEntryBillingsDownloadRequestBillingModel {
  AB = "AB",
  ABA = "ABA",
  OTHER = "OTHER",
  SABS = "SABS",
}

export type TaxiCorporationPlanEntryBillingsDownloadRequestQueryParams = {
  order?: TaxiCorporationPlanEntryBillingsDownloadRequestOrder;
  human_id?: string;
  date_since?: string;
  date_to?: string;
  driver?: string;
  billing_model?: TaxiCorporationPlanEntryBillingsDownloadRequestBillingModel;
  fleet_partner?: string;
  cargo_order_human_id?: number;
};

type TaxiCorporationPlanEntryBillingsDownloadRequest = {
  taxiCorporationUuid: string;
  order?: TaxiCorporationPlanEntryBillingsDownloadRequestOrder;
  humanId?: string;
  dateSince?: string;
  dateTo?: string;
  driver?: string;
  billingModel?: TaxiCorporationPlanEntryBillingsDownloadRequestBillingModel;
  fleetPartner?: string;
  cargoOrderHumanId?: number;
};

export default TaxiCorporationPlanEntryBillingsDownloadRequest;
